var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
import React, { useContext, useEffect, useState, useRef } from 'react';
import styled from 'styled-components';
import { Box, Flex, Button, Badge, IconButton, Tooltip, Image, ChatHeader } from 'pcln-design-system';
import { InformationOutline } from 'pcln-icons';
import { ChatbotDataContext } from './context/ChatbotDataContext';
var TRAVEL_BOT_LOGO = 'https://s1.pclncdn.com/design-assets/pcln-bot/logos/pcln_bot_penny_logo_v1.1.svg';
var StyledTooltip = /*#__PURE__*/styled(Tooltip).withConfig({
  displayName: "DefaultModalHeader__StyledTooltip",
  componentId: "sc-1efzyeg-0"
})(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  left: ", ";\n  width: 300px;\n  text-align: left;\n"], ["\n  left: ", ";\n  width: 300px;\n  text-align: left;\n"
/**
 * DefaultModalHeader for chat modal
 * @public
 */])), function (props) {
  return props.isMobile ? '16px' : '-8px';
});
/**
 * DefaultModalHeader for chat modal
 * @public
 */
export var DefaultModalHeader = function (props) {
  var _a = useContext(ChatbotDataContext),
    isLivePersonSessionActive = _a.isLivePersonSessionActive,
    isMobile = _a.isMobile;
  var _b = useState(false),
    isDisplayed = _b[0],
    setTooltipDisplayState = _b[1];
  var modalHeaderRef = useRef(null);
  useEffect(function () {
    if (props.onDefaultModalHeaderRendered) {
      props.onDefaultModalHeaderRendered();
    }
  }, []);
  useEffect(function () {
    // Todo This should be removed as soon as DS updates the ChatHeader to accept props to add the flexibility to hide or display the minimize Button.
    if (isLivePersonSessionActive) {
      modalHeaderRef.current.querySelectorAll('button')[1].style.display = 'inline-block';
    } else {
      modalHeaderRef.current.querySelectorAll('button')[1].style.display = 'none';
    }
  }, [isLivePersonSessionActive, props.speechEnabled]);
  var IconButtonProps = {
    ml: 2,
    id: 'openTooltipButton',
    'data-testid': 'openTooltipButton',
    title: 'open tooltip',
    onClick: function (e) {
      e.preventDefault();
      setTooltipDisplayState(!isDisplayed);
    },
    icon: React.createElement(InformationOutline, {
      size: 16
    })
  };
  return React.createElement(Box, {
    ref: modalHeaderRef
  }, React.createElement(ChatHeader, {
    onClose: isLivePersonSessionActive ? props.handleCloseButton : props.onClose,
    onMinimize: props.onClose
  }, React.createElement(Flex, {
    alignItems: 'center'
  }, React.createElement(Image, {
    src: TRAVEL_BOT_LOGO,
    height: '28',
    width: '68',
    alt: 'Travel Bot Logo'
  }), React.createElement(Badge, {
    color: 'primary',
    bg: 'background.light'
  }, "BETA"), props.onClearHistory && React.createElement(Button, {
    ml: '2',
    size: 'small',
    variation: 'plain',
    onClick: props.onClearHistory
  }, "Clear"), React.createElement(Box, {
    mr: '0'
  }, React.createElement(IconButton, __assign({}, IconButtonProps)), isDisplayed && React.createElement(StyledTooltip, {
    bg: 'background.darkest',
    color: 'background.lightest',
    zIndex: 10,
    center: isMobile,
    left: !isMobile,
    isMobile: isMobile
  }, "Powered by OpenAI. Chat transcripts are recorded for quality review purposes. Penny can make mistakes. Please do not share any personal information in the chat.", React.createElement("br", null), React.createElement("br", null), "\u00A9 2024 Priceline - Patent Pending")))));
};
var templateObject_1;